export const filterProjects = (projects, searchQuery, searchFilter) => {
    if (!searchQuery || searchQuery.trim() === '') {
        return projects;
    }

    const lowerSearchQuery = searchQuery.toLowerCase();

    return projects.filter(project => {
        const title = project.title || '';
        const tagline = project.tagline || '';
        const url = project.url || '';
        const todos = project.todos || [];

        const titleMatch = title.toLowerCase().includes(lowerSearchQuery);
        const taglineMatch = tagline.toLowerCase().includes(lowerSearchQuery);
        const urlMatch = url.toLowerCase().includes(lowerSearchQuery);
        const checklistMatch = todos.some(todo =>
            todo.text && todo.text.toLowerCase().includes(lowerSearchQuery)
        );

        if (searchFilter === 'all') {
            return titleMatch || taglineMatch || urlMatch || checklistMatch;
        } else if (searchFilter === 'title') {
            return titleMatch;
        } else if (searchFilter === 'description') {
            return taglineMatch;
        } else if (searchFilter === 'checklist') {
            return checklistMatch;
        } else if (searchFilter === 'url') {
            return urlMatch;
        }
        // In case of an unknown/unexpected filter, default to not filtering out the project.
        // However, the UI should only send valid filter values.
        return true;
    });
};
